import React, { PropsWithChildren } from 'react';
import { BackgroundOverlay, BaseContent, BaseModalContainer, CloseButtonContainer } from './BaseModal.styles';
import CloseIcon from 'src/app_previous/images/CloseIcon';
import { palette } from 'app_previous/styles/colors';

interface BaseModalProps extends PropsWithChildren {
  isVisible: boolean;
  handleClose: () => void;
  blockModalClose?: boolean;
  hideCloseButton?: boolean;
  width: number | string;
}

const BaseModal = ({
  children,
  isVisible,
  handleClose,
  blockModalClose = false,
  hideCloseButton = false,
  width,
}: BaseModalProps): JSX.Element => {
  const modalCloseHandler = () => {
    if (!blockModalClose) {
      handleClose();
    }
  };

  return (
    <BaseModalContainer isVisible={isVisible}>
      <BackgroundOverlay onClick={modalCloseHandler} />
      <BaseContent width={width}>
        {!blockModalClose && !hideCloseButton && (
          <CloseButtonContainer onClick={modalCloseHandler}>
            <CloseIcon rectColor={palette.greyText} />
          </CloseButtonContainer>
        )}
        {children}
      </BaseContent>
    </BaseModalContainer>
  );
};

export default BaseModal;
